import { Component, Input, OnInit } from '@angular/core';
import { AppStatisticalFormUser } from 'src/app/core/types/app-statistical-form-user.type';
import { StatisticalReportsCompareService } from 'src/app/pages/statistical-reports/base/statistical-reports-compare.service';

@Component({
    selector: 'app-current-organ-sent-status-aggregate-compare-statistics',
    templateUrl: './current-organ-sent-status-aggregate.component.html',
    standalone: false
})
export class CurrentOrganSentStatusAggregateCompareStatisticsComponent
  implements OnInit
{
  title: string = 'pages.currentOrganSentStatusAggregateCompareStatistics.title';
  doughnutChartId: string =
    'doughnut_currentOrganSentStatusAggregateCompareStatistics';
  barChartId: string = 'bar_currentOrganSentStatusAggregateCompareStatistics';
  userType: AppStatisticalFormUser = "currentOrganizationUsersList";

  @Input() getDailyItemsApiMethodName: string;
  @Input() getMonthlyItemsApiMethodName: string;

  constructor() {
    this.getDailyItemsApiMethodName =
      StatisticalReportsCompareService.getDailyItemsApiMethodName
        ? StatisticalReportsCompareService.getDailyItemsApiMethodName
        : 'statisticsGetCurrentOrganizationSendStatusDailyStatistics';

    this.getMonthlyItemsApiMethodName =
      StatisticalReportsCompareService.getMonthlyItemsApiMethodName
        ? StatisticalReportsCompareService.getMonthlyItemsApiMethodName
        : 'statisticsGetCurrentOrganizationSendStatusMonthlyStatistics';
  }

  ngOnInit(): void {}
}
